import React from "react";
import * as uuid from "uuid";
import { Button } from "../../../../components/Button";
import { Icon } from "../../../../components/core/Icon";
import { Steps } from "../../../../components/Steps";
import { ProductDrinkSizes } from "./Steps/ProductDrinkSizes";
import { ProductNameAndImageStep } from "./Steps/ProductNameAndImageStep";

import { Drawer } from "@components";
import styles from "../../../../../styles/add-product.module.scss";
import { Availability } from "../../../../utils/Availability";
import { OptionStepQuestion } from "./Steps/OptionStepQuestion";
import { ProductAvailabilityStep } from "./Steps/ProductAvailabilityStep";
import { ProductStepQuestion } from "./Steps/ProductStepQuestion";
import { ProductTagsStep } from "./Steps/ProductTagsStep";

const StepNames = {
  NAME_AND_IMAGE: "NAME_AND_IMAGE",
  SIZES: "SIZES",
  QUESTIONS: "QUESTIONS",
  // EXTRA_INGREDIENTS: 'EXTRA_INGREDIENTS',
  TAGS: "TAGS",
  AVAILABILITY: "AVAILABILITY",
};

const StepIndexes = {
  NAME_AND_IMAGE: 1,
  SIZES: 2,
  QUESTIONS: 3,
  TAGS: 4,
  AVAILABILITY: 5,
};

export class ProductSteps extends React.Component {
  state = {
    product: {
      type: "step",
      name: null,
      show: true,
      highlight: false,
      availability: null,
      extra_ingredients: [],
      items: [],
      sizes: [],
    },
    openOptionSteps: false,
    selectedOption: null,
    steps: 5,
    step: StepNames.NAME_AND_IMAGE,
    currentStep: StepIndexes.NAME_AND_IMAGE,
    disabled: true,
    isValid: true,
  };

  componentDidMount() {
    const { product: stateProduct } = this.state;
    const { product, category } = this.props;

    const defaultSizes = [
      ...category.sizes.map(({ id, parent, ...size }) => ({ ...size })),
    ];

    if (category.sizes.length == 0) {
      defaultSizes.push({
        name: "Tamanho Único",
        type: "size",
        ref_id: uuid.v4(),
        price: 0,
      });
    }

    this.setState({
      product: {
        ...stateProduct,
        ...product,
        sizes: defaultSizes,
        parent: category.id,
      },
    });
  }

  onChangeProduct(values) {
    const { product } = this.state;
    this.setState(
      { product: { ...product, ...values } },
      this.validateStep.bind(this)
    );
  }

  checkEmptyItems(obj) {
    if ("items" in obj && Array.isArray(obj.items) && obj.items.length > 0) {
      for (const item of obj.items) {
        if (Array.isArray(item.items) && item.items.length === 0) {
          return true;
        }
      }
    }
    return false;
  }

  onChangeOption(values) {
    const hasEmptyItems = this.checkEmptyItems(values);
    if (hasEmptyItems) this.setState({ isValid: false });
    else this.setState({ isValid: true });

    if (!values.items) return;

    const { selectedOption, product } = this.state;

    const findAndUpdateItem = (items) => {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        if (item.ref_id === selectedOption.ref_id) {
          const updatedItem = { ...item };

          updatedItem.items = values.items;

          if (values.items) {
            for (const childItem of values.items) {
              childItem.parent = selectedOption.id;
            }
          }

          items[i] = updatedItem;
          return true;
        }

        if (item.items && findAndUpdateItem(item.items)) {
          return true;
        }
      }
      return false;
    };

    findAndUpdateItem(product?.items);

    this.setState({ product }, this.validateStep.bind(this));
  }

  validateStep() {
    const { step, product } = this.state;
    switch (step) {
      case StepNames.NAME_AND_IMAGE:
        return this.setState({ disabled: !product || !product.name });
      case StepNames.SIZES:
        return this.setState({
          disabled: product.sizes.some(
            (size) => size.price == null || size.price < 0,
          ),
        });
      case StepNames.QUESTIONS:
        if (product.items.length == 0) {
          return this.setState({ disabled: false });
        }

        const hasEmptyQuestion = product.items.findIndex((q) => !q.name) > -1;
        const hasEmptyOption =
          product.items.findIndex(
            (q) => q.items.length == 0 || q.items.findIndex((o) => !o.name) > -1
          ) > -1;

        return this.setState({
          disabled: hasEmptyQuestion || hasEmptyOption,
        });

      // case StepNames.EXTRA_INGREDIENTS:
      //     return this.setState({
      //         disabled: (
      //             product.extra_ingredients.length > 0
      //             && !(product.extra_ingredients.reduce((previousExtra, extra) => {
      //                 return previousExtra && !!extra.name && extra.sizes.reduce((previousExtraSize, extraSize) => {
      //                     return previousExtraSize && !!extraSize.name && !!extraSize.price && Number(String(extraSize.price)) != NaN
      //                 }, true)
      //             }, true))
      //         )
      //     })
      case StepNames.TAGS:
        return this.setState({
          disabled: false,
        });
      case StepNames.AVAILABILITY:
        return this.setState({
          disabled: Availability.hasIncompleteAvailability(
            product.availability
          ),
        });
      default:
        return null;
    }
  }

  nextStep() {
    const { step, product } = this.state;
    const { category } = this.props;

    switch (step) {
      case StepNames.NAME_AND_IMAGE:
        return this.setState(
          {
            step: StepNames.SIZES,
            currentStep: StepIndexes.SIZES,
            disabled: true,
          },
          this.validateStep.bind(this)
        );
      case StepNames.SIZES:
        return this.setState(
          {
            step: StepNames.QUESTIONS,
            currentStep: StepIndexes.QUESTIONS,
            disabled: true,
          },
          this.validateStep.bind(this)
        );
      case StepNames.SIZES:
        return this.setState(
          {
            step: StepNames.QUESTIONS,
            currentStep: StepIndexes.QUESTIONS,
            disabled: true,
          },
          this.validateStep.bind(this)
        );
      case StepNames.QUESTIONS:
        return this.setState(
          {
            step: StepNames.TAGS,
            currentStep: StepIndexes.TAGS,
            disabled: true,
          },
          this.validateStep.bind(this)
        );
      case StepNames.TAGS:
        return this.setState(
          {
            step: StepNames.AVAILABILITY,
            currentStep: StepIndexes.AVAILABILITY,
            disabled: true,
          },
          this.validateStep.bind(this)
        );
      case StepNames.AVAILABILITY:
        return false;
    }
  }

  prevStep() {
    const { step, product } = this.state;
    const { category, onPrev } = this.props;

    switch (step) {
      case StepNames.SIZES:
        return this.setState(
          {
            step: StepNames.NAME_AND_IMAGE,
            currentStep: StepIndexes.NAME_AND_IMAGE,
            disabled: false,
          },
          this.validateStep.bind(this)
        );
      case StepNames.QUESTIONS:
        return this.setState(
          {
            step: StepNames.SIZES,
            currentStep: StepIndexes.SIZES,
            disabled: false,
          },
          this.validateStep.bind(this)
        );
      // case StepNames.EXTRA_INGREDIENTS:
      //     //Se não tiver tamanhos padrões, voltar para a seleção de tamanhos padrões
      //     return this.setState({
      //         step: category.default_sizes === false ? StepNames.DEFAULT_SIZES : StepNames.SIZES,
      //         currentStep: category.default_sizes === false ? 2 : 3,
      //         disabled: false
      //     }, this.validateStep.bind(this));
      case StepNames.TAGS:
        return this.setState(
          {
            step: StepNames.QUESTIONS,
            currentStep: StepIndexes.QUESTIONS,
            disabled: false,
          },
          this.validateStep.bind(this)
        );
      case StepNames.AVAILABILITY:
        return this.setState(
          {
            step: StepNames.TAGS,
            currentStep: StepIndexes.TAGS,
            disabled: false,
          },
          this.validateStep.bind(this)
        );
    }
  }

  onSave() {
    const { onSave } = this.props;
    const { product } = this.state;

    product.availability = Availability.getValidAvailability(
      product.availability
    );

    onSave && onSave(product);
  }

  render() {
    const { category, catalog } = this.props;
    const {
      product,
      currentStep,
      step,
      steps,
      disabled,
      openOptionSteps,
      selectedOption,
      isValid,
    } = this.state;

    const mountPayloadOption = this.onChangeOption.bind(this);

    return (
      <>
        <Steps steps={steps} currentStep={currentStep} />
        <div className={styles.scrollContainer}>
          {step == StepNames.NAME_AND_IMAGE && (
            <ProductNameAndImageStep
              product={product}
              onChange={this.onChangeProduct.bind(this)}
            />
          )}
          {step == StepNames.SIZES && (
            <ProductDrinkSizes
              category={category}
              product={product}
              onChange={this.onChangeProduct.bind(this)}
            />
          )}
          {step == StepNames.QUESTIONS && (
            <ProductStepQuestion
              catalog={catalog}
              product={product}
              onChange={this.onChangeProduct.bind(this)}
              handleOptionSteps={(option) => {
                this.setState({
                  openOptionSteps: true,
                  selectedOption: option,
                });
                this.setState(
                  {
                    edit: "steps",
                    productCopy: this.state.product,
                  },
                  this.validateStep.bind(this)
                );
              }}
            />
          )}

          {openOptionSteps && (
            <Drawer
              visible={openOptionSteps}
              onClose={() => this.setState({ openOptionSteps: false })}
              withoutTransition
              closeInFade={false}
              title="Adicionar etapas"
              showBackButton
              backButton={() => this.setState({ openOptionSteps: false })}
            >
              <OptionStepQuestion
                catalog={catalog}
                option={selectedOption}
                product={product}
                onChange={mountPayloadOption}
                handleOptionSteps={(option) => {
                  this.setState({
                    openOptionSteps: true,
                    selectedOption: option,
                  });
                  this.setState(
                    {
                      edit: "steps",
                      productCopy: this.state.product,
                    },
                    this.validateStep.bind(this)
                  );
                }}
              />

              <div className={styles.footer}>
                <Button
                  design="primary"
                  className="w-100"
                  onClick={this.onSave.bind(this)}
                  disabled={
                    disabled || product?.availability?.length === 0 || isValid
                  }
                >
                  Salvar alterações
                </Button>
              </div>
            </Drawer>
          )}

          {step == StepNames.TAGS && (
            <ProductTagsStep
              item={product}
              onChange={this.onChangeProduct.bind(this)}
            />
          )}
          {step == StepNames.AVAILABILITY && (
            <ProductAvailabilityStep
              item={product}
              onChange={this.onChangeProduct.bind(this)}
            />
          )}
        </div>
        <div
          className={`${styles.footer} ${
            step != StepNames.NAME_AND_IMAGE ? "justify-between" : "justify-end"
          }`}
        >
          {step !== StepNames.NAME_AND_IMAGE && (
            <Button design="default-icon" onClick={this.prevStep.bind(this)}>
              <Icon name="long-arrow-left" size="xl" />
            </Button>
          )}
          {step === StepNames.AVAILABILITY ? (
            <Button
              design="primary-icon"
              onClick={this.onSave.bind(this)}
              disabled={disabled}
            >
              <Icon name="check" size="xl" />
            </Button>
          ) : (
            <Button
              design="primary-icon"
              onClick={this.nextStep.bind(this)}
              disabled={disabled}
            >
              <Icon name="long-arrow-right" size="xl" />
            </Button>
          )}
        </div>
      </>
    );
  }
}
